import type { AdminCalendarOwner } from '@/api'

// How the admin lists name a user: `@username`, else the numeric Telegram id.
export function ownerName(owner: AdminCalendarOwner): string {
  return owner.username ? `@${owner.username}` : String(owner.telegram_user_id)
}

export function formatDate(value: string): string {
  try {
    return new Date(value).toLocaleString()
  } catch {
    return value
  }
}
